// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.applicationFillout__header {
  box-shadow: 0px 3px 20px #0000000a;
  -ms-box-shadow: 0px 3px 20px #0000000a;
  -webkit-box-shadow: 0px 3px 20px #0000000a;
  -moz-box-shadow: 0px 3px 20px #0000000a;
  border: 1px solid #edf0f2;
  padding: 5px 10px;
  border-radius: 4px;
  background: #fff;
  margin-bottom: 8px;
  align-items: center;
}
.applicationFillout__wrapper {
  display: flex;
  -webkit-display: flex;
  min-height: calc(100vh - 156px);
}
.applicationFillout--headingSearch {
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
}
.applicationFillout--headingSearchWrapper h3 {
  margin-bottom: 0;
  padding-right: 10px;
}
.applicationFillout--filterSearchWrapper {
  position: relative;
}
.applicationFillout--filterSearchBar {
  border: 1px solid #d6d6d6;
  border-radius: 3px;
  background: transparent;
  height: 25px;
  line-height: 25px;
  font-size: 14px;
  color: #1984bc;
  padding: 0 20px 0 10px;
  outline: none;
  width: 100%;
  margin-bottom: 15px;
}
.applicationFillout--iconSearch {
  cursor: pointer;
}
.applicationFillout--iconSearchClose {
  position: absolute;
  right: 0;
  top: 2px;
  cursor: pointer;
}
.applicationFillout_filters {
  width: 20%;
  margin-right: 16px;
  background: #fff;
}
.applicationFillout__content {
  width: calc(80% - 40px);
  padding: 20px 0;
}
.heading-icon-wrapper {
  display: flex;
  -webkit-display: flex;
  align-items: center;
}
.applicationFillout__header .applicationFillout__heading {
  margin-bottom: 0;
  line-height: 1.6;
}
.applicationFillout_filters {
  padding: 16px;
}
.applicationFillout_filtersHeader {
  display: flex;
  -webkit-display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #dedede;
  align-items: center;
  padding-bottom: 5px;
  margin-bottom: 20px;
}
.applicationFillout_filters .filterHeading {
  font-size: 16px;
  line-height: 1.5;
  color: #0177b5;
  font-weight: 500;
}
.applicationFillout_filters .clearAll {
  color: #e0a633;
  font-size: 12px;
  background: none;
  border: none;
  cursor: pointer;
}
.applicationFillout__caseInfoData {
  box-shadow: 0px 3px 20px #0000000a;
  -ms-box-shadow: 0px 3px 20px #0000000a;
  -webkit-box-shadow: 0px 3px 20px #0000000a;
  -moz-box-shadow: 0px 3px 20px #0000000a;
  border: 1px solid #edf0f2;
  padding: 10px 20px;
  border-radius: 4px;
  background: #fff;
  align-items: center;
}
.applicationFillout__caseID .caseLabel {
  font-size: 14px;
  color: #000000;
  font-weight: 500;
  line-height: 1.7;
}
.applicationFillout__caseID .caseID {
  color: #e0a633;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.7;
}
.applicationFillout__caseDate {
  font-size: 12px;
  line-height: 1.5;
  text-align: right;
  color: #999999;
}
.applicationFillout__caseDate .caseDate {
  color: #000;
}
.applicationFillout__formInfoHeader {
  display: flex;
  -webkit-display: flex;
  background: #f5f5f5;
  padding: 20px;
}
.applicationFillout__formInfoHeader > div {
  font-size: 14px;
  color: #505050;
  line-height: 1.4;
  font-weight: 500;
}
.applicationFillout__nameHeader {
  display: flex;
  display: -webkit-flex;
}
.applicationFillout__nameHeader,
.applicationFillout__formName {
  width: 35%;
}
.applicationFillout__carriersHeader,
.applicationFillout__formCarrier,
.applicationFillout__stateHeader,
.applicationFillout__formState {
  width: 20%;
}
.applicationFillout__productHeader,
.applicationFillout__formProduct {
  width: 25%;
}
.applicationFillout__formName {
  display: flex;
  -webkit-display: flex;
  padding-right: 15px;
}
.applicationFillout__formContentWrapper {
  background: #fff;
}
.applicationFillout__formContent {
  border-bottom: 1px solid #f5f5f5;
  padding: 20px;
  display: flex;
  -webkit-display: flex;
}
.applicationFillout__formContent .applicationFillout__tableLabel {
  font-size: 14px;
  line-height: 1.4;
  color: #505050;
}
.applicationFillout__checkbox label {
  display: inline-block;
}
.applicationFillout__selectAllPDF
  .applicationFillout__checkbox
  .applicationFillout__unchecked {
  border: 2px solid #505050;
}
.applicationFillout__checkbox .applicationFillout__unchecked {
  display: inline-block;
  height: 17px;
  width: 17px;
  border: 2px solid #dedede;
  border-radius: 4px;
}
.applicationFillout__checkbox
  input[type='checkbox']:checked
  + label
  > .applicationFillout__unchecked {
  display: none;
}
.applicationFillout__checkbox .applicationFillout__checked {
  display: none;
  height: 17px;
  width: 17px;
}
.applicationFillout__checkbox
  input[type='checkbox']:checked
  + label
  > .applicationFillout__checked {
  display: inline-block;
}
.applicationFillout__checkbox {
  margin-right: 5px;
}
.applicationFillout__checkbox > input[type='checkbox'] {
  display: none;
}
.applicationFillout__carrierName,
.applicationFillout__productName,
.applicationFillout__stateName {
  display: flex;
  -webkit-display: flex;
  margin-bottom: 20px;
  align-items: center;
}
.applicationFillout__carrierLabel,
.applicationFillout__productLabel,
.applicationFillout__stateLabel {
  color: #222222;
  font-size: 12px;
  line-height: 1;
}
.applicationFillout__noFilterData {
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  padding: 40px 0;
}
.icon--generatePDF {
  margin-right: 8px;
}
.button--generatePDF {
  display: flex;
  -webkit-display: flex;
  padding: 8px 15px;
  height: 35px;
  margin-left: 10px;
}
.button--generatePDF:disabled,
.button--generatePDF:disabled:hover {
  background: rgba(25, 132, 188, 0.7);
  border-color: #1984bc;
}
.applicationFillout_filtersCarrier,
.applicationFillout_filtersProduct {
  margin-bottom: 32px;
  border-bottom: 1px solid #dedede;
}
.applicationFillout--filterItems {
  overflow: auto;
  max-height: 165px;
  padding-top: 4px;
}
.applicationFillout__formInfo {
  position: relative;
}
.applicationFillout__loaderWrapper {
  background: rgba(255, 255, 255, 0.5);
  min-height: 60px;
  position: absolute;
  top: 60px;
  left: 0;
  width: 100%;
  height: calc(100% - 60px);
}
.applicationFillout__loader,
.applicationFillout__loader:before,
.applicationFillout__loader:after {
  border-radius: 50%;
  width: 2.5em;
  height: 2.5em;
  animation-fill-mode: both;
  animation: bblFadInOut 1.8s infinite ease-in-out;
}
.applicationFillout__loader {
  color: #000;
  font-size: 7px;
  position: relative;
  text-indent: -9999em;
  animation-delay: -0.16s;
  position: absolute;
  top: 37%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
}
.applicationFillout__loader:before,
.applicationFillout__loader:after {
  content: '';
  position: absolute;
  top: 0;
}
.applicationFillout__loader:before {
  left: -3.5em;
  animation-delay: -0.32s;
}
.applicationFillout__loader:after {
  left: 3.5em;
}

@keyframes bblFadInOut {
  0%,
  80%,
  100% {
    box-shadow: 0 2.5em 0 -1.3em;
  }
  40% {
    box-shadow: 0 2.5em 0 0;
  }
}
.applicationFillout__toastMessage {
  background: #f00;
}
.color-select-container {
  width: 100px;
  margin-left: 10px;
}
.color-btn-container {
  align-items: center;
}
.color-select {
  width: 100%;
  height: 35px;
  padding: 0 15px;
  border: 2px solid #d6d6d6;
  border-radius: 6px;
  background: transparent;
  font-size: 14px;
  color: #222222;
  outline: none;
}
.color-text {
  font-size: 14px;
  font-weight: 600;
  color: #0177b5;
}
`, "",{"version":3,"sources":["webpack://./src/components/pages/applicationFillout/ApplicationFillout.css"],"names":[],"mappings":"AAAA;EACE,kCAAkC;EAClC,sCAAsC;EACtC,0CAA0C;EAC1C,uCAAuC;EACvC,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,+BAA+B;AACjC;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,eAAe;AACjB;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,gCAAgC;EAChC,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,kCAAkC;EAClC,sCAAsC;EACtC,0CAA0C;EAC1C,uCAAuC;EACvC,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,qBAAqB;AACvB;AACA;;EAEE,UAAU;AACZ;AACA;;;;EAIE,UAAU;AACZ;AACA;;EAEE,UAAU;AACZ;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gCAAgC;EAChC,aAAa;EACb,aAAa;EACb,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;;;EAGE,yBAAyB;AAC3B;AACA;EACE,qBAAqB;EACrB,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;AACA;;;;EAIE,aAAa;AACf;AACA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;AACb;AACA;;;;EAIE,qBAAqB;AACvB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;;;EAGE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;;;EAGE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;AACnB;AACA;;EAEE,mCAAmC;EACnC,qBAAqB;AACvB;AACA;;EAEE,mBAAmB;EACnB,gCAAgC;AAClC;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,yBAAyB;AAC3B;AACA;;;EAGE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,gDAAgD;AAClD;AACA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,uBAAuB;EACvB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,oCAAoC;EACpC,wCAAwC;EACxC,qCAAqC;AACvC;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,MAAM;AACR;AACA;EACE,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,WAAW;AACb;;AAEA;EACE;;;IAGE,4BAA4B;EAC9B;EACA;IACE,uBAAuB;EACzB;AACF;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,aAAa;AACf;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB","sourcesContent":[".applicationFillout__header {\n  box-shadow: 0px 3px 20px #0000000a;\n  -ms-box-shadow: 0px 3px 20px #0000000a;\n  -webkit-box-shadow: 0px 3px 20px #0000000a;\n  -moz-box-shadow: 0px 3px 20px #0000000a;\n  border: 1px solid #edf0f2;\n  padding: 5px 10px;\n  border-radius: 4px;\n  background: #fff;\n  margin-bottom: 8px;\n  align-items: center;\n}\n.applicationFillout__wrapper {\n  display: flex;\n  -webkit-display: flex;\n  min-height: calc(100vh - 156px);\n}\n.applicationFillout--headingSearch {\n  margin-bottom: 10px;\n  display: flex;\n  justify-content: space-between;\n}\n.applicationFillout--headingSearchWrapper h3 {\n  margin-bottom: 0;\n  padding-right: 10px;\n}\n.applicationFillout--filterSearchWrapper {\n  position: relative;\n}\n.applicationFillout--filterSearchBar {\n  border: 1px solid #d6d6d6;\n  border-radius: 3px;\n  background: transparent;\n  height: 25px;\n  line-height: 25px;\n  font-size: 14px;\n  color: #1984bc;\n  padding: 0 20px 0 10px;\n  outline: none;\n  width: 100%;\n  margin-bottom: 15px;\n}\n.applicationFillout--iconSearch {\n  cursor: pointer;\n}\n.applicationFillout--iconSearchClose {\n  position: absolute;\n  right: 0;\n  top: 2px;\n  cursor: pointer;\n}\n.applicationFillout_filters {\n  width: 20%;\n  margin-right: 16px;\n  background: #fff;\n}\n.applicationFillout__content {\n  width: calc(80% - 40px);\n  padding: 20px 0;\n}\n.heading-icon-wrapper {\n  display: flex;\n  -webkit-display: flex;\n  align-items: center;\n}\n.applicationFillout__header .applicationFillout__heading {\n  margin-bottom: 0;\n  line-height: 1.6;\n}\n.applicationFillout_filters {\n  padding: 16px;\n}\n.applicationFillout_filtersHeader {\n  display: flex;\n  -webkit-display: flex;\n  justify-content: space-between;\n  border-bottom: 1px solid #dedede;\n  align-items: center;\n  padding-bottom: 5px;\n  margin-bottom: 20px;\n}\n.applicationFillout_filters .filterHeading {\n  font-size: 16px;\n  line-height: 1.5;\n  color: #0177b5;\n  font-weight: 500;\n}\n.applicationFillout_filters .clearAll {\n  color: #e0a633;\n  font-size: 12px;\n  background: none;\n  border: none;\n  cursor: pointer;\n}\n.applicationFillout__caseInfoData {\n  box-shadow: 0px 3px 20px #0000000a;\n  -ms-box-shadow: 0px 3px 20px #0000000a;\n  -webkit-box-shadow: 0px 3px 20px #0000000a;\n  -moz-box-shadow: 0px 3px 20px #0000000a;\n  border: 1px solid #edf0f2;\n  padding: 10px 20px;\n  border-radius: 4px;\n  background: #fff;\n  align-items: center;\n}\n.applicationFillout__caseID .caseLabel {\n  font-size: 14px;\n  color: #000000;\n  font-weight: 500;\n  line-height: 1.7;\n}\n.applicationFillout__caseID .caseID {\n  color: #e0a633;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 1.7;\n}\n.applicationFillout__caseDate {\n  font-size: 12px;\n  line-height: 1.5;\n  text-align: right;\n  color: #999999;\n}\n.applicationFillout__caseDate .caseDate {\n  color: #000;\n}\n.applicationFillout__formInfoHeader {\n  display: flex;\n  -webkit-display: flex;\n  background: #f5f5f5;\n  padding: 20px;\n}\n.applicationFillout__formInfoHeader > div {\n  font-size: 14px;\n  color: #505050;\n  line-height: 1.4;\n  font-weight: 500;\n}\n.applicationFillout__nameHeader {\n  display: flex;\n  display: -webkit-flex;\n}\n.applicationFillout__nameHeader,\n.applicationFillout__formName {\n  width: 35%;\n}\n.applicationFillout__carriersHeader,\n.applicationFillout__formCarrier,\n.applicationFillout__stateHeader,\n.applicationFillout__formState {\n  width: 20%;\n}\n.applicationFillout__productHeader,\n.applicationFillout__formProduct {\n  width: 25%;\n}\n.applicationFillout__formName {\n  display: flex;\n  -webkit-display: flex;\n  padding-right: 15px;\n}\n.applicationFillout__formContentWrapper {\n  background: #fff;\n}\n.applicationFillout__formContent {\n  border-bottom: 1px solid #f5f5f5;\n  padding: 20px;\n  display: flex;\n  -webkit-display: flex;\n}\n.applicationFillout__formContent .applicationFillout__tableLabel {\n  font-size: 14px;\n  line-height: 1.4;\n  color: #505050;\n}\n.applicationFillout__checkbox label {\n  display: inline-block;\n}\n.applicationFillout__selectAllPDF\n  .applicationFillout__checkbox\n  .applicationFillout__unchecked {\n  border: 2px solid #505050;\n}\n.applicationFillout__checkbox .applicationFillout__unchecked {\n  display: inline-block;\n  height: 17px;\n  width: 17px;\n  border: 2px solid #dedede;\n  border-radius: 4px;\n}\n.applicationFillout__checkbox\n  input[type='checkbox']:checked\n  + label\n  > .applicationFillout__unchecked {\n  display: none;\n}\n.applicationFillout__checkbox .applicationFillout__checked {\n  display: none;\n  height: 17px;\n  width: 17px;\n}\n.applicationFillout__checkbox\n  input[type='checkbox']:checked\n  + label\n  > .applicationFillout__checked {\n  display: inline-block;\n}\n.applicationFillout__checkbox {\n  margin-right: 5px;\n}\n.applicationFillout__checkbox > input[type='checkbox'] {\n  display: none;\n}\n.applicationFillout__carrierName,\n.applicationFillout__productName,\n.applicationFillout__stateName {\n  display: flex;\n  -webkit-display: flex;\n  margin-bottom: 20px;\n  align-items: center;\n}\n.applicationFillout__carrierLabel,\n.applicationFillout__productLabel,\n.applicationFillout__stateLabel {\n  color: #222222;\n  font-size: 12px;\n  line-height: 1;\n}\n.applicationFillout__noFilterData {\n  font-size: 16px;\n  font-weight: 600;\n  text-align: center;\n  padding: 40px 0;\n}\n.icon--generatePDF {\n  margin-right: 8px;\n}\n.button--generatePDF {\n  display: flex;\n  -webkit-display: flex;\n  padding: 8px 15px;\n  height: 35px;\n  margin-left: 10px;\n}\n.button--generatePDF:disabled,\n.button--generatePDF:disabled:hover {\n  background: rgba(25, 132, 188, 0.7);\n  border-color: #1984bc;\n}\n.applicationFillout_filtersCarrier,\n.applicationFillout_filtersProduct {\n  margin-bottom: 32px;\n  border-bottom: 1px solid #dedede;\n}\n.applicationFillout--filterItems {\n  overflow: auto;\n  max-height: 165px;\n  padding-top: 4px;\n}\n.applicationFillout__formInfo {\n  position: relative;\n}\n.applicationFillout__loaderWrapper {\n  background: rgba(255, 255, 255, 0.5);\n  min-height: 60px;\n  position: absolute;\n  top: 60px;\n  left: 0;\n  width: 100%;\n  height: calc(100% - 60px);\n}\n.applicationFillout__loader,\n.applicationFillout__loader:before,\n.applicationFillout__loader:after {\n  border-radius: 50%;\n  width: 2.5em;\n  height: 2.5em;\n  animation-fill-mode: both;\n  animation: bblFadInOut 1.8s infinite ease-in-out;\n}\n.applicationFillout__loader {\n  color: #000;\n  font-size: 7px;\n  position: relative;\n  text-indent: -9999em;\n  animation-delay: -0.16s;\n  position: absolute;\n  top: 37%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  -webkit-transform: translate(-50%, -50%);\n  -moz-transform: translate(-50%, -50%);\n}\n.applicationFillout__loader:before,\n.applicationFillout__loader:after {\n  content: '';\n  position: absolute;\n  top: 0;\n}\n.applicationFillout__loader:before {\n  left: -3.5em;\n  animation-delay: -0.32s;\n}\n.applicationFillout__loader:after {\n  left: 3.5em;\n}\n\n@keyframes bblFadInOut {\n  0%,\n  80%,\n  100% {\n    box-shadow: 0 2.5em 0 -1.3em;\n  }\n  40% {\n    box-shadow: 0 2.5em 0 0;\n  }\n}\n.applicationFillout__toastMessage {\n  background: #f00;\n}\n.color-select-container {\n  width: 100px;\n  margin-left: 10px;\n}\n.color-btn-container {\n  align-items: center;\n}\n.color-select {\n  width: 100%;\n  height: 35px;\n  padding: 0 15px;\n  border: 2px solid #d6d6d6;\n  border-radius: 6px;\n  background: transparent;\n  font-size: 14px;\n  color: #222222;\n  outline: none;\n}\n.color-text {\n  font-size: 14px;\n  font-weight: 600;\n  color: #0177b5;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
